export default {
  init() {
    // JavaScript to be fired on all pages
    
    $('#city-selector').change(function(){
      var selectedCity = $(this).val();

      $('.gallery-box').show();

      if(selectedCity != 'all'){
        $('.gallery-box[data-location!="'+selectedCity+'"]').hide({duration: 400});
      }

    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateGalleries.js